import { Card, Skeleton } from "antd";
import React from "react";

export const SkeletonConnectionItem = () => {
    return (
        <Card className="newUI-subtle" loading>
            <div style={{ padding: 20 }}>
                <Skeleton avatar active paragraph={{ rows: 4 }} />
            </div>
        </Card>
    );
};
